
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'

import {fetch,promptMessage } from '../../api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import tabsilde from '@/components/tabslideTamplete.vue';
import {getken} from '@/api/getToken';
export default {
data(){
return {
location:'',
vvv:false,
gonggao:'',
lengdongprice:'',
lengdongpriceoption:[],
peitaiprice:'',
peitaipriceoption:[],
submintDisabled:false,
contentH:0,
tabIndex: 0,
tabNameArry: ['',''],
frozenradioList:[],
chooseIf:false,
frozeneggchooseIf:false,
freezeIf:false,
noembryoIf:false,
radioList:[]

}
},
components:{
CheckIcon ,Flexbox, FlexboxItem,Checker, CheckerItem,XHeader,Radio ,XButton,Group,'V-tabsilde':tabsilde,Divider
},
watch: {
contentH: function (newValue, oldValue) {
$('.content>.tabslider>.shift>.ZDYswipercontent').css({'height':newValue +'px'});
},
},
created(){

},
methods:{
getUserId(){
this.$store.commit('updateLoadingStatus',{isLoading:true})
fetch('get',urlConfig.GetSfzh +'?openid='+this.$route.query.openid).then(response => {
this.patineSex = response.sex;
if(response.sex == '女性'){
this.tabNameArry=['我的胚胎','我的冻卵'];
this.frozenType = urlConfig.frozeneggGetList;
}else{
this.frozenType = urlConfig.frozenSemenGetList;
this.tabNameArry=['我的胚胎','我的冻精'];
}
this.sfzh = response.sfzh;
let _this = this;
this.getPersonInfoId(response.sfzh).then(function (data) {
return _this.EmbryoList(response.sfzh);
}).then(function(data){
return _this.frozeneggList(response.sfzh);
})

}).catch(error => {

})
this.gethongdongDate();
},
gethongdongDate(){
fetch('get',urlConfig.myEmbryohuodongDate).then(response => {
if(response.END_DATE){
this.gonggao ='活动截止时间为'+ response.END_DATE.split(' ')[0];
}


}).catch(error => {

})
},  //活动期限
getPersonInfoId(sfzh){
let _this = this;
return new Promise(function(resolve, reject){
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
resolve();
_this.personInfoId = response.personInfoId;


}).catch(error => {

})
})
},
windResize(){
this.contentH = window.innerHeight -46 -46;
},
tabClick(index){
this.tabIndex = index;
this.choosetype();
},
frozeneggList(sfzh){

let _this = this;
return new Promise(function(resolve, reject){
fetch('get',_this.frozenType + '?sfzh='+sfzh).then(response => {
if(response.length == 0){
_this.frozeneggchooseIf = false;
_this.freezeIf = true;
}else {
_this.frozeneggchooseIf = true;
_this.freezeIf = false;
_this.frozenradioList = response;
_this.frozenradioList[0].checked = true;

if(_this.patineSex == '女性'){
_this.getpeitaiPriceData('01','lengdongprice','lengdongpriceoption');
}else{
_this.getpeitaiPriceData('02','lengdongprice','lengdongpriceoption');
}
}
}).catch(error => {

})
})
}, //获取冻卵/精信息
getpeitaiPriceData(sflxDm,value,option){
fetch('post',urlConfig.myEmbryoGetPrice+ '?sflxDm='+ sflxDm).then(response => {
console.log(34,response)
this[option] = response;
this[value] = this[option][1].DIAGCODE;
this.choosetype();
}).catch(error => {

})
},
EmbryoList(sfzh){
let _this = this;
return new Promise(function(resolve, reject){
fetch('get',urlConfig.myEmbryoGetList + '?sfzh='+sfzh).then(response => {
resolve();
if(response.length == 0){
_this.chooseIf = false;
_this.noembryoIf = true;
}else {
_this.radioList = response;
_this.chooseIf = true;
_this.noembryoIf = false;
_this.radioList[0].checked = true;
_this.getpeitaiPriceData('03','peitaiprice','peitaipriceoption');

}
_this.$store.commit('updateLoadingStatus',{isLoading:false})


}).catch(error => {

})
})
}, //获取胚胎信息
renew(){
this.submintDisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true})
this.timestamp = Date.parse(new Date());
console.log(this.yearParma,45)
fetch('post',urlConfig.myEmbryoRenew,this.yearParma).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false})
window.location.href = "http://app.cdxt.com.cn/"+this.location+"/pages/payMain.html?t="+this.timestamp;
this.submintDisabled = false;

}).catch(error => {
if(error == "您还存在未交费的胚胎续费订单"){
window.location.href = "http://app.cdxt.com.cn/"+this.location+"/pages/payMain.html?t="+this.timestamp;
}else {
promptMessage('提示',error);
}
this.submintDisabled = false;
})
}, //续费
cancel(){
this.$store.commit('updateLoadingStatus',{isLoading:true})
fetch('post',urlConfig.myEmbryoCancel +'?sfzh='+this.sfzh).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示',"订单已取消");

}).catch(error => {

})
}, //取消订单
information(id,index,item){
this.yearParma.set('chargeId',id);
this.$nextTick(function(){
for(let i =0;i<this[item].length;i++){
this[item][i].checked = false;
}
this[item][index].checked = true;
})

console.log(this[item])
},  //选择续费哪条信息
choosetype(){
this.yearParma = new URLSearchParams();
this.yearParma.set('personInfoId',this.personInfoId);

if(this.tabIndex == 0) {  //我的胚胎
console.log(this.peitaipriceoption[1],222)
this.yearParma.set('goodsId',this.peitaipriceoption[1].DIAGCODE);
this.yearParma.set('goodsPrice',this.peitaipriceoption[1].UNITPRICE);
this.yearParma.set('chargeId',this.radioList[0].CHARGEID);
this.yearParma.set('sflxdm','03');

}else{
if(this.patineSex == '女性'){
this.yearParma.set('sflxdm','01');
}else {
this.yearParma.set('sflxdm','02');
}
console.log(this.lengdongpriceoption[1],333)
this.yearParma.set('goodsId',this.lengdongpriceoption[1].DIAGCODE);
this.yearParma.set('goodsPrice',this.lengdongpriceoption[1].UNITPRICE);
this.yearParma.set('chargeId',this.frozenradioList[0].CHARGEID);
}
},
peitaipriceChange(value,option){
for(let i=0;i<option.length;i++){
if(value == option[i].DIAGCODE){
this.yearParma.set('goodsPrice',option[i].UNITPRICE);
this.yearParma.set('goodsId',value);
console.log(this.peitaiprice,value,option[i].UNITPRICE)
}
}


}  //选择价位
},

mounted(){
getken(this.getUserId);
this.windResize();
this.location="scvif";
if(this.$route.query.hosCode=='510100000008'){
this.location="sgtszzx";
}


}
}



// WEBPACK FOOTER //
// ./src/project/myEmbryoProject/myEmbryo.vue